<template>
  <div style="font-size: 11px;cursor: pointer">
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="setVendorDestinationStatus" title=""
               top="5vh" width="98%">
      <voip-testing-panel :defaultDestination="destinationId" :defaultDivision="vendorDivisionId" :defaultRate="rateId"
                          :editMode="false" :onCreateCallback="callEstablished"
                          v-if="dialogVisible"></voip-testing-panel>
    </el-dialog>

    <el-dialog :append-to-body="true" :close-on-click-modal="false"
               :close-on-press-escape="false" :visible.sync="vendorDestinationStatusDialogVisible"
               class="call-test-results-dialog" title=""
               top="4vh" width="300px">
      <vendorDestinationStatus :broadcast="broadcast" v-if="vendorDestinationStatusDialogVisible"
                               @closeModel="closeVendorDestinationStatus"></vendorDestinationStatus>
    </el-dialog>


    <div v-if="!prefix">

    </div>
    <div v-else-if="!mouseover">
      <div v-if="!isUserReseller && !isUserCustomer">
        {{ (vendor) ? String(vendor).slice(0, 15) : '' }}
      </div>
      {{ prefix }}
    </div>
    <div @click="openDialog" v-else-if="prefix">
      <i class="el-icon-phone" style="font-size: 21px;padding-top: 4px"></i>
    </div>
  </div>
</template>

<script>


import panelMixin from '@/app/portals/cpanel/mixins/util'

export default {
  mixins: [panelMixin],
  components: {
    vendorDestinationStatus: () => import('@/modules/voip-testing-panel/vendor-destination-status/View'),
    voipTestingPanel: () => import('@/modules/voip-testing-panel/broadcast-form/View')
  },
  props: {
    vendor: {
      required: true
    },
    rateId: {
      required: true
    },
    destinationId: {
      required: true
    },
    prefix: {
      required: true
    },
    rateKey: {
      required: true
    },
    destKey: {
      required: true
    },
    callIsOnGoingFunc: {
      required: true
    }
  },
  data() {
    return {
      broadcast: {a: 0},
      vendorDestinationStatusDialogVisible: false,
      isChecked: null,
      dialogVisible: false,
      mouseover: false,
      vendorDivisionId: null,
      isUserReseller: $store.getters['user-state/isUserReseller'],
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      isUserCustomerOrReseller: $store.getters['user-state/isUserCustomer'] || $store.getters['user-state/isUserReseller'],
      dom: null
    }
  },
  mounted() {
    this.isChecked = this.checked
    this.dom = this.$el
    this.dom.parentNode.addEventListener('mouseover', () => {
      this.mouseover = true
    })

    this.dom.parentNode.addEventListener('mouseleave', () => {
      this.mouseover = false
    })
  },
  methods: {
    closeVendorDestinationStatus(newStatus) {
      this.vendorDestinationStatusDialogVisible = false
      if (newStatus != 1) {
        this.$emit('refreshTable', {})
      }
    },
    callEstablished(dataMessage) {
      this.callIsOnGoingFunc(this.destKey, this.rateKey, dataMessage)
    },
    openDialog() {
      this.panelMixin_getVendorDivisionByName({name: this.vendor}, (r) => {
        this.vendorDivisionId = r.data
        this.dialogVisible = true
      })
    },
    ...$mapActions('voip-vendor-api', {getVendorDivisionByName: 'getVendorDivisionByName'}),
    setVendorDestinationStatus() {
      if (!this.isUserCustomerOrReseller) {
        let ctx = this
        let lastBroadcastId = this.$store.state['voip-testing-panel-state'].lastBroadcastId;
        if (!lastBroadcastId || this.isUserCustomerOrReseller) return

        $store.dispatch('voip-testing-panel-api/getBroadcastData', {id: lastBroadcastId}).then((r) => {
          ctx.broadcast = r.data
          $vue.nextTick(() => {
            ctx.vendorDestinationStatusDialogVisible = true
          })
        })
      }
    }
  },
}
</script>
